export default defineNuxtPlugin((nuxtApp) => {
	const runtimeConfig = useRuntimeConfig()
	const { $apiHelper } = useNuxtApp()

	const buildApiUrl = (appendPath) => {
		return runtimeConfig.public.SERVICES.MOTHERSHIP_API_URL + "events/" + appendPath
	}

	nuxtApp.provide("eventApiService", {
		$getLatestPaymentOffset: async (eventId, successHandler) => {
			const url = buildApiUrl(`${eventId}/payment-date-offset`)

			const requestOptions = {}
			requestOptions.method = "GET"
			requestOptions.headers = $apiHelper.$authedRequestHeader()

			$apiHelper.$performRequest(url, requestOptions, successHandler)
		},
	})
})
